<!--
 * @Author: Tahiti
 * @Date: 2025-10-22 21:28:30
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-01-06 12:23:37
 * @Description: 
 * @FilePath: /weryai-web/components/LoginModal.vue
-->
<template>
    <ClientOnly>
        <el-dialog
            v-model="showLoginModal"
            @close="closeLoginModal"
            class="z-100 login-modal !w-[90vw] md:!w-[454px] md:!h-auto"
            :show-close="false"
            :z-index="10000"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            align-center
            style="--el-dialog-padding-primary: 0"
        >
            <!-- 邀请提示条 - 当有邀请人信息时显示 -->
            <div v-if="inviterInfo" class="invite-banner">
                <img
                    src="https://static.weryai.com/cms/horn.webp"
                    alt="horn"
                    class="invite-horn-icon"
                />
                <div class="invite-banner-content">
                    <span class="invite-banner-text">
                        <span class="inviter-name">{{
                            inviterInfo.nickname
                        }}</span>
                        {{ t('invitation.invitedToTry') }}
                    </span>
                    <span class="invite-banner-reward">
                        {{ t('invitation.signUpReward') }}
                        <span class="reward-points">{{
                            inviterInfo.reward_points
                        }}</span>
                        {{ t('invitation.extraCredits') }}
                    </span>
                </div>
            </div>

            <!-- email password login form————login form -->
            <div class="flex flex-col items-center justify-center">
                <div
                    v-if="stepEnums[currentStep].value === 'login'"
                    class="flex flex-col items-center px-[30px] py-[25px] login-bg login-step-bg"
                    v-loading="loading"
                >
                    <div
                        class="flex flex-col items-center justify-center w-full"
                    >
                        <div
                            class="text-[28px] md:text-[40px] font-[900] w-full flex items-center justify-center text-white"
                        >
                            {{ t('login.welcome') }}
                        </div>
                        <div
                            class="w-full text-center text-[12px] md:text-[14px] text-[#adadad] mb-5 mt-2"
                        >
                            {{ t('login.title1') }}
                        </div>
                    </div>

                    <div class="w-full">
                        <div
                            v-if="GOOGLE_LOGIN_ENABLED"
                            class="w-full hidden-box"
                        >
                            <el-button
                                class="google-login-btn w-full"
                                @click="googleLogin"
                            >
                                <img
                                    src="../assets/images/login/google-icon.webp"
                                    alt="Google"
                                    class="w-[24px] h-[24px]"
                                />
                                <div
                                    class="text-[14px] md:text-[16px] font-[500] ml-[10px] text-[#060508]"
                                >
                                    {{ t('common_login_register.google') }}
                                </div>
                            </el-button>
                        </div>
                        <!-- divider -->
                        <div
                            v-if="GOOGLE_LOGIN_ENABLED"
                            class="divider hidden-box"
                        >
                            <div class="divider-line-right"></div>
                            <div class="mx-[10px]">
                                {{ t('common_login_register.or') }}
                            </div>
                            <div class="divider-line-left"></div>
                        </div>

                        <div v-if="loginMode === 'email'" class="w-full">
                            <el-form
                                ref="loginFormRef"
                                :model="loginForm"
                                :rules="loginRules"
                                label-position="top"
                            >
                                <el-form-item prop="email">
                                    <el-input
                                        class="mobile-input"
                                        style="width: 100%"
                                        type="email"
                                        :placeholder="
                                            t('common_login_register.email')
                                        "
                                        v-model="loginForm.email"
                                        @blur="validateEmail"
                                    >
                                        <template #prefix>
                                            <img
                                                :src="EmailIcon"
                                                alt="email"
                                                class="w-[20px] h-[20px]"
                                            />
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item
                                    prop="password"
                                    class="mt-[20px] md:mt-[30px]"
                                >
                                    <el-input
                                        class="mobile-input"
                                        style="width: 100%"
                                        type="password"
                                        :placeholder="t('login.password')"
                                        v-model="loginForm.password"
                                        show-password
                                    >
                                        <template #prefix>
                                            <img
                                                :src="PwdIcon"
                                                alt="pwd"
                                                class="w-[20px] h-[20px]"
                                            />
                                        </template>
                                    </el-input>
                                </el-form-item>

                                <el-form-item class="mt-[20px] md:mt-[30px]">
                                    <el-button
                                        class="confirm-btn"
                                        @click="loginWithEmailPwd"
                                        :loading="loginLoading"
                                        :disabled="
                                            googleLoginLoading ||
                                            loginForm.email === '' ||
                                            loginForm.password === ''
                                        "
                                    >
                                        {{ t('common_login_register.login') }}
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div v-else class="w-full">
                            <el-form
                                ref="phoneLoginFormRef"
                                :model="phoneLoginForm"
                                :rules="phoneLoginRules"
                                label-position="top"
                            >
                                <div class="phone-login-row">
                                    <div class="phone-combined-input">
                                        <div
                                            class="phone-area-item phone-fixed-area-code"
                                            aria-label="phone area code"
                                        >
                                            +{{ FIXED_PHONE_AREA_CODE }}
                                        </div>
                                        <span
                                            class="phone-input-divider"
                                            aria-hidden="true"
                                        ></span>
                                        <el-form-item
                                            prop="phone"
                                            class="phone-number-item"
                                        >
                                            <el-input
                                                class="mobile-input phone-number-input"
                                                style="width: 100%"
                                                type="tel"
                                                :placeholder="t('login.phone')"
                                                v-model="phoneLoginForm.phone"
                                                maxlength="20"
                                            />
                                        </el-form-item>
                                    </div>
                                </div>

                                <el-form-item
                                    prop="verifyCode"
                                    class="mt-[20px] md:mt-[30px]"
                                >
                                    <el-input
                                        class="mobile-input"
                                        style="width: 100%"
                                        :placeholder="
                                            t('register.verificationCode')
                                        "
                                        v-model="phoneLoginForm.verifyCode"
                                        :maxlength="4"
                                        :minlength="4"
                                    >
                                        <template #prefix>
                                            <img
                                                :src="VerifyCodeIcon"
                                                alt="verify_code"
                                                class="w-[20px] h-[20px]"
                                            />
                                        </template>
                                        <template #suffix>
                                            <button
                                                type="button"
                                                v-if="!isPhoneCounting"
                                                class="text-text-active hover:!text-text-active hover:underline"
                                                style="border: none"
                                                :disabled="
                                                    phoneVerifyCodeLoading ||
                                                    !phoneLoginForm.areaCode ||
                                                    !phoneLoginForm.phone
                                                "
                                                @mousedown.prevent.stop
                                                @click.stop="
                                                    handleSendPhoneVerifyCode
                                                "
                                            >
                                                {{ t('register.sendCode') }}
                                            </button>
                                            <div v-else>
                                                {{ phoneCountDown }}s
                                            </div>
                                        </template>
                                    </el-input>
                                </el-form-item>

                                <el-form-item class="mt-[20px] md:mt-[30px]">
                                    <el-button
                                        class="confirm-btn"
                                        @click="loginWithPhoneCode"
                                        :loading="loginLoading"
                                        :disabled="
                                            googleLoginLoading ||
                                            phoneLoginForm.areaCode === '' ||
                                            phoneLoginForm.phone === '' ||
                                            phoneLoginForm.verifyCode === ''
                                        "
                                    >
                                        {{ t('common_login_register.login') }}
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="login-bottom-actions">
                            <div class="login-register-line">
                                <span>{{ t('login.detail1') }}</span>
                                <el-link
                                    underline="never"
                                    class="text-login ml-1 !text-login-text hover:!text-text-active hover:underline"
                                    @click="handleToRegister"
                                >
                                    {{ t('login.detail2') }}
                                </el-link>
                            </div>
                            <div class="login-secondary-line">
                                <button
                                    type="button"
                                    class="login-mode-switch-btn"
                                    @click="handleSwitchLoginMode"
                                >
                                    {{
                                        loginMode === 'phone'
                                            ? t('login.useEmailPasswordLogin')
                                            : t('login.usePhoneCodeLogin')
                                    }}
                                </button>
                                <template v-if="loginMode === 'email'">
                                    <span
                                        class="login-secondary-divider"
                                    ></span>
                                    <span
                                        class="login-forgot-password"
                                        @click="currentStep = 4"
                                    >
                                        {{ t('findPassword.forgotPassword') }}
                                    </span>
                                    <el-popover
                                        width="200"
                                        :content="t('findPassword.tip')"
                                        popper-style="z-index: 10001;"
                                        effect="dark"
                                    >
                                        <template #reference>
                                            <el-icon
                                                class="ml-[5px] cursor-help"
                                            >
                                                <QuestionFilled />
                                            </el-icon>
                                        </template>
                                    </el-popover>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- getVerifyCodeForm -->
                <div
                    v-if="stepEnums[currentStep].value === 'get_verify_code'"
                    class="flex flex-col items-center justify-center px-[20px] md:px-[30px] py-[20px] md:py-[25px] login-bg"
                    v-loading="loading"
                >
                    <div
                        class="flex flex-col items-center justify-center w-full"
                    >
                        <div
                            class="text-[28px] md:text-[40px] font-[900] tracking-[-0.8px] mb-6 md:mb-10 break-words"
                        >
                            {{ t('register.createAccount') }}
                        </div>
                        <div
                            class="w-full text-center text-[12px] md:text-[14px] text-[#adadad] mb-[20px] md:mb-[40px] hidden"
                        >
                            {{ t('register.title2') }}
                        </div>
                    </div>

                    <div class="w-full">
                        <div
                            v-if="GOOGLE_LOGIN_ENABLED"
                            class="w-full hidden-box"
                        >
                            <el-button
                                class="google-login-btn w-full"
                                @click="googleLoginByRegister"
                            >
                                <img
                                    src="../assets/images/login/google-icon.webp"
                                    alt="Google"
                                    class="w-[24px] h-[24px]"
                                />
                                <div
                                    class="text-[14px] md:text-[16px] font-[500] ml-[10px] text-[#060508]"
                                >
                                    {{ t('common_login_register.google') }}
                                </div>
                            </el-button>
                        </div>
                        <!-- divider -->
                        <div
                            v-if="GOOGLE_LOGIN_ENABLED"
                            class="divider hidden-box"
                        >
                            <div class="divider-line-right"></div>
                            <div class="mx-[10px]">
                                {{ t('common_login_register.or') }}
                            </div>
                            <div class="divider-line-left"></div>
                        </div>
                        <div class="w-full">
                            <el-form
                                ref="getVerificationFormRef"
                                :model="verifyCodeForm"
                                :rules="verifyCodeFormRule"
                                label-position="top"
                            >
                                <el-form-item prop="email">
                                    <el-input
                                        class="mobile-input"
                                        style="width: 100%"
                                        type="email"
                                        :placeholder="
                                            t('common_login_register.email')
                                        "
                                        v-model="verifyCodeForm.email"
                                    >
                                        <template #prefix>
                                            <img
                                                :src="EmailIcon"
                                                alt="email"
                                                class="w-[20px] h-[20px]"
                                            />
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item class="mt-[20px] md:mt-[40px]">
                                    <el-button
                                        class="confirm-btn"
                                        @click="getVerifyCode"
                                        :disabled="verifyCodeForm.email === ''"
                                    >
                                        {{ t('register.getVerifyCode') }}
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div
                            class="w-full flex items-center justify-center mt-[20px] md:mt-[40px]"
                        >
                            <div
                                class="text-[12px] md:text-[14px] text-[#adadad] flex items-center justify-center"
                            >
                                {{ t('register.detail1') }}
                                <el-link
                                    underline="never"
                                    class="text-login !text-login-text hover:!text-text-active hover:underline"
                                    @click="handleToLogin"
                                    >{{ t('register.detail2') }}</el-link
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <!-- verifyCode Form -->
                <div
                    v-if="stepEnums[currentStep].value === 'fill_verify_code'"
                    class="flex flex-col items-center px-[30px] py-[32px] login-bg"
                    v-loading="loading"
                >
                    <div
                        class="flex flex-col items-center justify-center w-full"
                    >
                        <div
                            class="text-[40px] font-[900] tracking-[-0.8px] whitespace-nowrap"
                        >
                            {{ t('register.createAccount') }}
                        </div>
                        <div
                            class="w-full text-center text-[14px] text-[#adadad] mb-[40px]"
                        >
                            {{ t('register.title2') }}
                        </div>
                    </div>

                    <div class="w-full">
                        <div
                            v-if="GOOGLE_LOGIN_ENABLED"
                            class="w-full hidden-box"
                        >
                            <el-button
                                class="google-login-btn w-full"
                                @click="googleLogin"
                            >
                                <img
                                    src="../assets/images/login/google-icon.webp"
                                    alt="Google"
                                    class="w-[24px] h-[24px]"
                                />
                                <div
                                    class="text-[14px] md:text-[16px] font-[500] ml-[10px] text-[#060508]"
                                >
                                    {{ t('common_login_register.google') }}
                                </div>
                            </el-button>
                        </div>

                        <!-- divider -->
                        <div
                            v-if="GOOGLE_LOGIN_ENABLED"
                            class="divider hidden-box"
                        >
                            <div class="divider-line-right"></div>
                            <div class="mx-[10px]">
                                {{ t('common_login_register.or') }}
                            </div>
                            <div class="divider-line-left"></div>
                        </div>
                        <div class="w-full">
                            <el-form
                                class="w-full"
                                ref="verifyCodeFormRef"
                                :model="verifyCodeForm"
                                :rules="verifyCodeFormRule"
                            >
                                <el-form-item prop="email">
                                    <el-input
                                        class="mobile-input"
                                        style="width: 100%"
                                        type="email"
                                        :placeholder="
                                            t('common_login_register.email')
                                        "
                                        v-model="verifyCodeForm.email"
                                        :disabled="isCounting"
                                    >
                                        <template #prefix>
                                            <img
                                                :src="EmailIcon"
                                                alt="email"
                                                class="w-[20px] h-[20px]"
                                            />
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="verifyCode">
                                    <el-input
                                        class="mobile-input"
                                        style="width: 100%"
                                        :placeholder="
                                            t('register.verificationCode')
                                        "
                                        v-model="verifyCodeForm.verifyCode"
                                        :maxlength="6"
                                        :minlength="6"
                                    >
                                        <template #prefix>
                                            <img
                                                :src="VerifyCodeIcon"
                                                alt="verify_code"
                                                class="w-[20px] h-[20px]"
                                            />
                                        </template>
                                        <template #suffix>
                                            <button
                                                type="button"
                                                v-if="!isCounting"
                                                class="text-text-active hover:!text-text-active hover:underline"
                                                style="border: none"
                                                ref="getVerifyCodeBtn"
                                                :disabled="
                                                    !verifyCodeForm.email
                                                "
                                                @click.stop="
                                                    handleSendVerifyCode
                                                "
                                            >
                                                {{ t('register.sendCode') }}
                                            </button>
                                            <div v-else>{{ countDown }}s</div>
                                        </template>
                                    </el-input>
                                    <div
                                        class="text-[10px] md:text-[12px] text-[#adadad] text-left leading-[150%] w-full flex items-center mt-[6px]"
                                    >
                                        <span
                                            class="text-red-500 mr-[4px] text-[12px]"
                                            >*</span
                                        >
                                        {{ t('register.trash_can') }}
                                    </div>
                                </el-form-item>

                                <el-form-item class="mt-[20px] md:mt-[40px]">
                                    <el-button
                                        class="confirm-btn"
                                        @click="toRegister"
                                        :loading="registerLoading"
                                        :disabled="
                                            verifyCodeForm.verifyCode === ''
                                        "
                                    >
                                        {{ t('register.continue') }}
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div
                            class="w-full flex items-center justify-center mt-[15px] md:mt-[20px]"
                        >
                            <div
                                class="text-[12px] md:text-[14px] text-[#adadad]"
                            >
                                {{ t('register.detail1') }}
                                <el-link
                                    underline="never"
                                    class="!text-login-text hover:!text-text-active hover:underline"
                                    @click="handleToLogin"
                                    >{{ t('register.detail2') }}</el-link
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <!-- login for register form-->
                <div
                    v-if="stepEnums[currentStep].value === 'register'"
                    class="flex flex-col items-center px-[30px] py-[32px] login-bg"
                    v-loading="loading"
                >
                    <div
                        class="flex flex-col items-center justify-center w-full"
                    >
                        <div
                            class="text-[40px] font-[900] tracking-[-0.8px] whitespace-nowrap"
                        >
                            {{ t('register.createAccount') }}
                        </div>
                        <div
                            class="w-full text-center text-[14px] text-[#adadad] mb-[40px]"
                        >
                            {{ t('register.title2') }}
                        </div>
                    </div>

                    <div class="w-full">
                        <div
                            v-if="GOOGLE_LOGIN_ENABLED"
                            class="w-full hidden-box"
                        >
                            <el-button
                                class="google-login-btn w-full"
                                @click="googleLogin"
                            >
                                <img
                                    src="../assets/images/login/google-icon.webp"
                                    alt="Google"
                                    class="w-[24px] h-[24px]"
                                />
                                <div
                                    class="text-[14px] md:text-[16px] font-[500] ml-[10px] text-[#060508]"
                                >
                                    {{ t('common_login_register.google') }}
                                </div>
                            </el-button>
                        </div>

                        <!-- divider -->
                        <div
                            v-if="GOOGLE_LOGIN_ENABLED"
                            class="divider hidden-box"
                        >
                            <div class="divider-line-right"></div>
                            <div class="mx-[10px]">
                                {{ t('common_login_register.or') }}
                            </div>
                            <div class="divider-line-left"></div>
                        </div>
                        <div class="w-full">
                            <el-form
                                ref="pwdFormRef"
                                :model="pwdForm"
                                :rules="pwdFormRule"
                                label-position="top"
                            >
                                <el-form-item prop="password">
                                    <el-input
                                        class="mobile-input"
                                        style="width: 100%"
                                        type="password"
                                        :placeholder="t('register.newPassword')"
                                        v-model="pwdForm.password"
                                        show-password
                                    >
                                        <template #prefix>
                                            <img
                                                :src="PwdIcon"
                                                alt="pwd"
                                                class="w-[20px] h-[20px]"
                                            />
                                        </template>
                                    </el-input>
                                </el-form-item>

                                <el-form-item prop="confirmPassword">
                                    <el-input
                                        class="mobile-input"
                                        style="width: 100%"
                                        type="password"
                                        :placeholder="t('register.confirm')"
                                        v-model="pwdForm.confirmPassword"
                                        show-password
                                    >
                                        <template #prefix>
                                            <img
                                                :src="PwdIcon"
                                                alt="pwd"
                                                class="w-[20px] h-[20px]"
                                            />
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <!-- <el-form-item  prop="register_code">
                  <el-input
                    style="width: 100%; height: 60px"
                    type="text"
                    :placeholder="t('common_login_register.register_code')"
                    v-model="pwdForm.register_code"
                    maxlength="8"
                    minlength="8"
                  >
                    <template #prefix>
                      <img
                        :src="VerifyCodeIcon"
                        alt="verify_code"
                        class="w-[20px] h-[20px]"
                      />
                    </template>
                  </el-input>
                </el-form-item> -->
                                <el-form-item class="mt-[20px] md:mt-[40px]">
                                    <el-button
                                        class="confirm-btn"
                                        @click="handleRegister"
                                        :loading="registerLoding"
                                        :disabled="
                                            pwdForm.password === '' ||
                                            pwdForm.confirmPassword === ''
                                        "
                                    >
                                        {{ t('register.confirmCreate') }}
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div
                            class="w-full flex items-center justify-center mt-[20px] md:mt-[40px]"
                        >
                            <div
                                class="text-[12px] md:text-[14px] text-[#adadad]"
                            >
                                {{ t('register.detail1') }}
                                <el-link
                                    underline="never"
                                    class="!text-login-text hover:!text-text-active hover:underline"
                                    @click="handleToLogin"
                                    >{{ t('register.detail2') }}</el-link
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="stepEnums[currentStep].value === 'reset_password'"
                    class="flex flex-col items-center px-[30px] py-[32px] login-bg"
                    v-loading="loading"
                >
                    <div
                        class="flex flex-col items-center justify-center w-full"
                    >
                        <div
                            class="text-[28px] md:text-[40px] font-[900] w-full flex items-center justify-center break-words"
                        >
                            {{ t('findPassword.findBackPassword') }}
                        </div>
                        <div
                            class="w-full text-center text-[12px] md:text-[14px] text-[#adadad] mb-[20px] md:mb-[40px]"
                        >
                            {{ t('findPassword.title') }}
                        </div>
                    </div>

                    <div class="w-full">
                        <el-form
                            ref="resetPasswordFormRef"
                            :model="resetPasswordForm"
                            :rules="resetPasswordRules"
                            label-position="top"
                        >
                            <el-form-item prop="email">
                                <el-input
                                    style="width: 100%; height: 60px"
                                    type="email"
                                    :placeholder="
                                        t('common_login_register.email')
                                    "
                                    v-model="resetPasswordForm.email"
                                >
                                    <template #prefix>
                                        <img
                                            :src="EmailIcon"
                                            alt="email"
                                            class="w-[20px] h-[20px]"
                                        />
                                    </template>
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="password">
                                <el-input
                                    style="width: 100%; height: 60px"
                                    type="password"
                                    :placeholder="t('login.password')"
                                    v-model="resetPasswordForm.password"
                                    show-password
                                >
                                    <template #prefix>
                                        <img
                                            :src="PwdIcon"
                                            alt="pwd"
                                            class="w-[20px] h-[20px]"
                                        />
                                    </template>
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="confirmPassword">
                                <el-input
                                    style="width: 100%; height: 60px"
                                    type="password"
                                    :placeholder="t('register.confirm')"
                                    v-model="resetPasswordForm.confirmPassword"
                                    show-password
                                >
                                    <template #prefix>
                                        <img
                                            :src="PwdIcon"
                                            alt="pwd"
                                            class="w-[20px] h-[20px]"
                                        />
                                    </template>
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="verifyCode">
                                <el-input
                                    class="mobile-input"
                                    style="width: 100%"
                                    :placeholder="
                                        t('register.verificationCode')
                                    "
                                    v-model="resetPasswordForm.verifyCode"
                                    :maxlength="6"
                                    :minlength="6"
                                >
                                    <template #prefix>
                                        <img
                                            :src="VerifyCodeIcon"
                                            alt="verify_code"
                                            class="w-[20px] h-[20px]"
                                        />
                                    </template>
                                    <template #suffix>
                                        <button
                                            type="button"
                                            v-if="!isCounting"
                                            class="text-text-active hover:!text-text-active hover:underline"
                                            style="border: none"
                                            ref="getVerifyCodeBtn"
                                            :disabled="!resetPasswordForm.email"
                                            @click.stop="handleSendVerifyCode"
                                        >
                                            {{ t('register.sendCode') }}
                                        </button>
                                        <div v-else>{{ countDown }}s</div>
                                    </template>
                                </el-input>
                            </el-form-item>
                            <el-form-item class="mt-[40px]">
                                <el-button
                                    class="confirm-btn"
                                    @click="handleResetPassword"
                                    :loading="resetPwdLoading"
                                    :disabled="
                                        resetPasswordForm.email === '' ||
                                        resetPasswordForm.password === '' ||
                                        resetPasswordForm.confirmPassword ===
                                            '' ||
                                        resetPasswordForm.verifyCode === ''
                                    "
                                >
                                    {{ t('findPassword.resetPassword') }}
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="w-full flex items-center justify-center">
                        <div class="text-[12px] md:text-[14px] text-[#545463]">
                            {{ t('register.detail1') }}
                            <el-link
                                underline="never"
                                class="!text-login-text hover:!text-text-active hover:underline"
                                @click="handleToLogin"
                                >{{ t('register.detail2') }}</el-link
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full flex justify-center mt-5">
                <img
                    src="../assets/images/common/close.webp"
                    alt="close"
                    class="w-[32px] h-[32px] md:w-[40px] md:h-[40px] cursor-pointer hover:scale-105 transition-all duration-300"
                    @click="closeLoginModal"
                />
            </div>

            <template #header>
                <button
                    type="button"
                    class="el-dialog__headerbtn left-0"
                    v-if="currentStep === 3 || currentStep === 2"
                    @click="currentStep--"
                >
                    <el-icon>
                        <ArrowLeft />
                    </el-icon>
                </button>
            </template>
        </el-dialog>
    </ClientOnly>
</template>

<script setup>
import { ref, computed, nextTick, onMounted, onUnmounted, watch } from 'vue'
import { ArrowLeft, QuestionFilled } from '@element-plus/icons-vue'
import {
    checkEmailStatusApi,
    loginApi,
    getVerifyCodeApi,
    getPhoneVerifyCodeApi,
    resetPasswordApi,
    checkEmailVerifyCodeStatusApi,
} from '@/api/login'
import { useUserStore } from '@/stores/user'
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import { auth as firebaseAuth } from '@/utils/firebase'
import { useI18n } from '~/composables/useI18n'
import { noticeMessagePopup } from '~/utils/common'
import EmailIcon from '~/assets/images/login/email.svg'
import PwdIcon from '~/assets/images/login/pwd.svg'
import VerifyCodeIcon from '~/assets/images/login/verify_code.svg'
import storage from '~/utils/localstorage'
import {
    closeLoginModal,
    emitter,
    handleGlobalLoginSuccess,
    emitOpenSignInModal,
} from '~/utils/emitter'
import { getTodaySignStatusApi, getInviterInfoApi } from '@/api/user'
import { useAppStore } from '@/stores/app'
import { GOOGLE_LOGIN_ENABLED, SIGN_IN_ENABLED } from '~/utils/feature-flags'

const { t } = useI18n()
const store = useUserStore()
const appStore = useAppStore()
const showLoginModal = ref(false)
const FIXED_PHONE_AREA_CODE = '86'

// ==================== 邀请人信息 ====================
const DEFAULT_INVITER_NAME = 'A friend'
const DEFAULT_REWARD_POINTS = 10

// 邀请人信息（当有邀请码时显示）
const inviterInfo = ref(null)

// 加载邀请人信息
const loadInviterInfo = async () => {
    try {
        const storedInviteCode = storage.get('reward_invite_code')
        if (!storedInviteCode) {
            inviterInfo.value = null
            return
        }

        // 尝试从 localStorage 获取缓存的邀请人信息
        const cachedInfo = storage.get('inviter_info')
        if (cachedInfo) {
            try {
                inviterInfo.value = JSON.parse(cachedInfo)
                return
            } catch {
                // 解析失败，继续调用接口
            }
        }

        // 调用接口获取邀请人信息
        const res = await getInviterInfoApi(storedInviteCode)
        if (res?.data) {
            inviterInfo.value = {
                nickname: res.data.user_name || DEFAULT_INVITER_NAME,
                reward_points: res.data.reward_points ?? DEFAULT_REWARD_POINTS,
            }
            // 缓存邀请人信息
            storage.set(
                'inviter_info',
                JSON.stringify(inviterInfo.value),
                7 * 24 * 60 * 60 * 1000
            )
        } else {
            // 接口返回空数据，使用默认值
            inviterInfo.value = {
                nickname: DEFAULT_INVITER_NAME,
                reward_points: DEFAULT_REWARD_POINTS,
            }
        }
    } catch (error) {
        console.error('获取邀请人信息失败:', error)
        // 接口失败，检查是否有邀请码，有则使用默认值
        const storedInviteCode = storage.get('reward_invite_code')
        if (storedInviteCode) {
            inviterInfo.value = {
                nickname: DEFAULT_INVITER_NAME,
                reward_points: DEFAULT_REWARD_POINTS,
            }
        } else {
            inviterInfo.value = null
        }
    }
}

// 清除邀请人信息（登录成功后调用）
const clearInviterInfo = () => {
    inviterInfo.value = null
    storage.remove('inviter_info')
}

// 暂停第三方脚本的 DOM 操作
const pauseThirdPartyScripts = () => {
    // 暂停 YouTube 嵌入视频的自动播放
    const youtubeIframes = document.querySelectorAll(
        'iframe[src*="youtube.com/embed"]'
    )
    youtubeIframes.forEach(iframe => {
        iframe.style.pointerEvents = 'none'
    })
}

// 恢复第三方脚本的 DOM 操作
const resumeThirdPartyScripts = () => {
    // 恢复 YouTube 嵌入视频的交互
    const youtubeIframes = document.querySelectorAll(
        'iframe[src*="youtube.com/embed"]'
    )
    youtubeIframes.forEach(iframe => {
        iframe.style.pointerEvents = 'auto'
    })
}

// 监听登录弹窗事件
emitter.on('show-login-modal', _data => {
    showLoginModal.value = true
    // 暂停第三方脚本的 DOM 操作
    pauseThirdPartyScripts()
    // 只有在邀请落地页上下文中才加载邀请人信息
    if (_data?.context === 'invitation') {
        loadInviterInfo()
    } else {
        // 非邀请上下文，清除邀请人信息
        inviterInfo.value = null
    }
})

emitter.on('close-login-modal', () => {
    showLoginModal.value = false
    // 恢复第三方脚本的 DOM 操作
    resumeThirdPartyScripts()
})

const stepEnums = [
    {
        label: '登录',
        value: 'login',
    },
    {
        label: '获取验证码',
        value: 'get_verify_code',
    },
    {
        label: '填写验证码',
        value: 'fill_verify_code',
    },
    {
        label: '邮箱注册',
        value: 'register',
    },
    {
        label: '找回密码',
        value: 'reset_password',
    },
]
const currentStep = defineModel('currentStep', {
    type: Number,
    default: 0,
})

// 步骤配置
const steps = ref(stepEnums)

// 登录成功后获取用户信息
const hasLoginForGetInitInfo = async (res, login_method) => {
    store.setUserData(res.data.access_token, res.data.user_info_resp)
    closeLoginModal()
    // 登录成功后清除邀请人信息
    clearInviterInfo()
    await store.getUserCurrentContext()

    await store.getUserInfo()
    appStore.getCommonEnums()
    emitter.emit('refresh-creation-history')
    appStore.getProjectList()

    // 触发登录成功事件
    const loginSuccessEvent = new CustomEvent('loginSuccess')
    window.dispatchEvent(loginSuccessEvent)

    // 使用全局登录成功处理
    await handleGlobalLoginSuccess()

    // 埋点：根据 new_user 字段判断是登录还是注册成功
    if (import.meta.client && typeof window !== 'undefined' && res.data) {
        // 尝试多种可能的字段名
        const isNewUser =
            res.data['new user'] === true ||
            res.data['new_user'] === true ||
            res.data.is_new_user === true ||
            res.data.isNewUser === true ||
            res.data.new_user === true ||
            res.data.user_info_resp?.first_login === true

        // 获取登录方式
        let method = 'email_pwd'
        if (login_method === 'google') {
            method = 'google'
        } else if (login_method === 'phone') {
            method = 'phone'
        }

        import('~/utils/log-event-func')
            .then(({ analyticsEvent }) => {
                if (isNewUser) {
                    // 新用户注册成功
                    analyticsEvent('register_result_suc', {
                        regist_method: method,
                    })
                } else {
                    // 老用户登录成功
                    analyticsEvent('login_result_suc', {
                        login_method: method,
                    })
                }
            })
            .catch(() => {
                // 静默失败，不影响主流程
            })

        // 签到弹窗自动弹出逻辑
        handleAutoSignInPopup(isNewUser)
    }
}

// 处理签到弹窗自动弹出
const handleAutoSignInPopup = async isNewUser => {
    if (!import.meta.client || !SIGN_IN_ENABLED) return

    // 检查是否在1小时间隔内已弹出过
    const lastPopupTime = localStorage.getItem('lastSignInPopupTime')
    const now = Date.now()
    const ONE_HOUR = 60 * 60 * 1000 // 1小时（毫秒）

    if (lastPopupTime && now - Number(lastPopupTime) < ONE_HOUR) {
        // 距离上次弹出不足1小时，不弹出
        return
    }

    // 立即设置标记，防止与 userStore.checkAndShowSignInPopup 的竞态条件
    localStorage.setItem('lastSignInPopupTime', String(now))

    if (isNewUser) {
        // 新用户：存储标记，并立即弹出一次
        localStorage.setItem('newUserSignInPending', 'true')
        setTimeout(() => {
            emitOpenSignInModal()
        }, 1000)
    } else {
        // 老用户：检查今日签到状态，未签到则弹出
        try {
            const signRes = await getTodaySignStatusApi()
            if (signRes?.data?.sign_status === 'NOT_SIGN') {
                // 延迟弹出，避免与其他弹窗冲突
                setTimeout(() => {
                    emitOpenSignInModal()
                }, 1000)
            }
        } catch (error) {
            console.error('获取签到状态失败:', error)
        }
    }
}

// email validation
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const emailValidator = (rule, value, callback) => {
    if (!value) {
        callback(new Error(t('rules.email1')))
    }
    if (!emailRegex.test(value)) {
        callback(new Error(t('rules.email2')))
    }
    callback()
}

// password validation
const passwordValidator = (rule, value, callback) => {
    if (!value) {
        callback(new Error(t('rules.pwd1')))
    } else if (
        currentStep.value === 3 &&
        pwdForm.value.confirmPassword &&
        value !== pwdForm.value.confirmPassword
    ) {
        callback(new Error(t('rules.confirmPwd1')))
    } else if (
        currentStep.value === 4 &&
        resetPasswordForm.value.confirmPassword &&
        value !== resetPasswordForm.value.confirmPassword
    ) {
        callback(new Error(t('rules.confirmPwd1')))
    }
    callback()
}
const confirmPasswordValidator = (rule, value, callback) => {
    if (!value) {
        callback(new Error(t('rules.confirmPwd1')))
    }
    if (
        currentStep.value === 3 &&
        pwdForm.value.password &&
        value !== pwdForm.value.password
    ) {
        callback(new Error(t('rules.confirmPwd1')))
    } else if (
        currentStep.value === 4 &&
        resetPasswordForm.value.password &&
        value !== resetPasswordForm.value.password
    ) {
        callback(new Error(t('rules.confirmPwd1')))
    }
    callback()
}
// verify verifyCode
const verifyCodeValidator = (rule, value, callback) => {
    if (!value) {
        return callback(new Error(t('rules.verifyCode2')))
    } else if (value.length !== 6 || isNaN(Number(value))) {
        return callback(new Error(t('rules.verifyCode3')))
    }
    callback()
}

const phoneVerifyCodeValidator = (rule, value, callback) => {
    if (!value) {
        return callback(new Error(t('rules.verifyCode2')))
    } else if (value.length !== 4 || isNaN(Number(value))) {
        return callback(new Error(t('rules.verifyCode3')))
    }
    callback()
}

const normalizePhoneNumber = phone => String(phone || '').replace(/[^\d]/g, '')

const areaCodeValidator = (rule, value, callback) => {
    if (!value) {
        return callback(new Error(t('rules.areaCode1')))
    } else if (!/^\d{1,4}$/.test(String(value))) {
        return callback(new Error(t('rules.areaCode2')))
    }
    callback()
}

const phoneValidator = (rule, value, callback) => {
    const normalizedPhone = normalizePhoneNumber(value)
    if (!value) {
        return callback(new Error(t('rules.phone1')))
    } else if (
        !/^[\d\s-]+$/.test(String(value)) ||
        normalizedPhone.length < 5 ||
        normalizedPhone.length > 20
    ) {
        return callback(new Error(t('rules.phone2')))
    }
    callback()
}

const DEFAULT_LOGIN_MODE = 'email'
const loginMode = ref(DEFAULT_LOGIN_MODE)
const loginForm = ref({
    email: '',
    password: '',
})
const loginFormRef = ref(null)
const loginRules = ref({
    email: [{ validator: emailValidator, trigger: 'blur' }],
    password: [
        { validator: passwordValidator, trigger: 'blur' },
        { min: 8, max: 20, message: t('rules.password3'), trigger: 'blur' },
        { message: t('rules.password2'), trigger: 'blur', pattern: /^\S*$/ },
    ],
})

const handleSwitchLoginMode = async () => {
    loginMode.value = loginMode.value === 'phone' ? 'email' : 'phone'
    await nextTick()
    loginFormRef.value?.clearValidate?.()
    phoneLoginFormRef.value?.clearValidate?.()
}

const handleToRegister = () => {
    // 埋点：点击注册弹窗
    if (import.meta.client && typeof window !== 'undefined') {
        import('~/utils/log-event-func').then(({ analyticsEvent }) => {
            analyticsEvent('click_register', {
                web_site: window.location.pathname,
            })
        })
    }
    currentStep.value++
    loginFormRef.value?.resetFields()
}
const handleToLogin = () => {
    currentStep.value = 0
    getVerificationFormRef.value?.resetFields()
    verifyCodeFormRef.value?.resetFields()
    phoneLoginFormRef.value?.resetFields()
    pwdFormRef.value?.resetFields()
    resetPasswordFormRef.value?.resetFields()
}

const loginLoading = ref(false)
const showLoginApiError = (
    res,
    fallbackMessage = t('rules.login_failed'),
    type = 'warning'
) => {
    noticeMessagePopup(
        res?.message || res?.desc || fallbackMessage,
        t('common.tip'),
        type,
        3000,
        'cool-notification'
    )
}

const loginWithEmailPwd = async () => {
    await loginFormRef.value?.validate()
    if (loginLoading.value) return
    loginLoading.value = true
    const data = {
        email: loginForm.value.email,
        ticket: loginForm.value.password,
        oauth_enum: 'EMAIL_LOGIN',
    }
    const invite_code = storage.get('invite_code')
    if (invite_code) {
        data.invite_code = invite_code
    }
    // 添加奖励邀请码
    const reward_invite_code = storage.get('reward_invite_code')
    if (reward_invite_code) {
        data.reward_invite_code = reward_invite_code
    }
    try {
        const res = await loginApi(data)
        if (res.status === 200) {
            hasLoginForGetInitInfo(res, 'email')
        } else if (res.status === 500) {
            showLoginApiError(res, t('rules.login_failed'), 'error')
            signInForm.value.password = ''
        } else if (res.status === 2101) {
            showLoginApiError(res, t('rules.email_not_registered'))
        } else {
            showLoginApiError(res)
        }
    } catch (_e) {
        showLoginApiError(_e?.data)
    } finally {
        loginLoading.value = false
    }
}

const phoneLoginForm = ref({
    areaCode: FIXED_PHONE_AREA_CODE,
    phone: '',
    verifyCode: '',
})
const phoneLoginFormRef = ref(null)
const phoneLoginRules = ref({
    areaCode: [{ validator: areaCodeValidator, trigger: 'blur' }],
    phone: [{ validator: phoneValidator, trigger: 'blur' }],
    verifyCode: [{ validator: phoneVerifyCodeValidator, trigger: 'blur' }],
})
const phoneVerifyCodeLoading = ref(false)
const phoneCountDown = ref(0)
const phoneTimer = ref(null)
const isPhoneCounting = computed(() => phoneCountDown.value > 0)

const clearPhoneVerifyCodeTimer = () => {
    if (phoneTimer.value) {
        clearInterval(phoneTimer.value)
        phoneTimer.value = null
    }
    phoneCountDown.value = 0
}

const startPhoneVerifyCodeTimer = () => {
    clearPhoneVerifyCodeTimer()
    phoneCountDown.value = 60
    phoneTimer.value = setInterval(() => {
        phoneCountDown.value--
        if (phoneCountDown.value <= 0) {
            clearPhoneVerifyCodeTimer()
        }
    }, 1000)
}

const verifyCodeForm = ref({
    email: '',
    verifyCode: '',
})
const verifyCodeFormRule = ref({
    email: [{ validator: emailValidator, trigger: 'blur' }],
    verifyCode: [{ validator: verifyCodeValidator, trigger: 'blur' }],
})
const verifyCodeFormRef = ref(null)
const getVerificationFormRef = ref(null)

const getVerifyCode = async () => {
    await getVerificationFormRef.value?.validateField('email')
    currentStep.value++
    await nextTick()
    handleSendVerifyCode()
}

// debounce function
const debounce = (func, wait) => {
    let timeout
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout)
            func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
    }
}

const handleSendPhoneVerifyCode = debounce(async () => {
    if (phoneVerifyCodeLoading.value || isPhoneCounting.value) return
    phoneLoginFormRef.value?.clearValidate?.('verifyCode')
    await phoneLoginFormRef.value?.validateField('phone')
    await nextTick()
    phoneLoginFormRef.value?.clearValidate?.('verifyCode')

    phoneVerifyCodeLoading.value = true
    startPhoneVerifyCodeTimer()
    try {
        const res = await getPhoneVerifyCodeApi({
            area_code: Number(phoneLoginForm.value.areaCode),
            phone: normalizePhoneNumber(phoneLoginForm.value.phone),
        })

        if (res.status === 200) {
            noticeMessagePopup(
                t('rules.verifyCode_sent'),
                t('common.tip'),
                'success',
                3000,
                'cool-notification'
            )
        } else if (res.status === 2112) {
            clearPhoneVerifyCodeTimer()
            noticeMessagePopup(
                res.message || res.desc || t('rules.send_failed'),
                t('common.tip'),
                'warning',
                5000,
                'cool-notification'
            )
        } else {
            clearPhoneVerifyCodeTimer()
        }
    } catch (_error) {
        clearPhoneVerifyCodeTimer()
        if (!_error?.data?.message) {
            noticeMessagePopup(
                t('rules.send_failed'),
                t('common.tip'),
                'warning',
                3000,
                'cool-notification'
            )
        }
    } finally {
        phoneVerifyCodeLoading.value = false
    }
}, 300)

const loginWithPhoneCode = async () => {
    await phoneLoginFormRef.value?.validate()
    if (loginLoading.value) return
    loginLoading.value = true
    const data = {
        area_code: Number(phoneLoginForm.value.areaCode),
        phone: normalizePhoneNumber(phoneLoginForm.value.phone),
        ticket: phoneLoginForm.value.verifyCode,
        oauth_enum: 'PHONE',
    }
    const invite_code = storage.get('invite_code')
    if (invite_code) {
        data.invite_code = invite_code
    }
    const reward_invite_code = storage.get('reward_invite_code')
    if (reward_invite_code) {
        data.reward_invite_code = reward_invite_code
    }
    try {
        const res = await loginApi(data)
        if (res.status === 200) {
            hasLoginForGetInitInfo(res, 'phone')
        } else {
            showLoginApiError(res)
        }
    } catch (_e) {
        showLoginApiError(_e?.data)
    } finally {
        loginLoading.value = false
    }
}

// verifyCode countdown
const countDown = ref(0)
const isCounting = computed(() => {
    return countDown.value > 0
})
// timer reference
const timer = ref(null)

const clearEmailVerifyCodeTimer = () => {
    if (timer.value) {
        clearInterval(timer.value)
        timer.value = null
    }
    countDown.value = 0
}

// debounce handle send verifyCode method
const handleSendVerifyCode = debounce(async () => {
    // immediately start countdown (user experience priority)
    countDown.value = 60
    timer.value = setInterval(() => {
        countDown.value--
        if (countDown.value <= 0) {
            clearInterval(timer.value)
            timer.value = null
        }
    }, 1000)

    try {
        const res = await getVerifyCodeApi({
            email:
                currentStep.value === 2
                    ? verifyCodeForm.value.email
                    : resetPasswordForm.value.email,
            ticket_use_type:
                currentStep.value === 2 ? 'REGISTER' : 'UPDATE_PWD', //重置or注册
        })

        if (res.status === 200) {
            noticeMessagePopup(
                t('rules.verifyCode_sent'),
                t('common.tip'),
                'success',
                3000,
                'cool-notification'
            )
        } else if (res.status === 2112) {
            clearEmailVerifyCodeTimer()
            noticeMessagePopup(
                res.message || res.desc || t('rules.send_failed'),
                t('common.tip'),
                'warning',
                5000,
                'cool-notification'
            )
        } else if ([2132, 2117].includes(res.status)) {
            // specific error code handling
            clearEmailVerifyCodeTimer()
        } else if ([2131, 2111].includes(res.status)) {
            // other error code handling
            clearEmailVerifyCodeTimer()
        } else if (res.status === 500) {
            clearEmailVerifyCodeTimer()
            //currentStep.value = 0;
        }
    } catch (_error) {
        // network exception or other error
        clearEmailVerifyCodeTimer()
        if (!_error?.data?.message) {
            noticeMessagePopup(
                t('rules.send_failed'),
                t('common.tip'),
                'warning',
                3000,
                'cool-notification'
            )
        }
    }
}, 300)

const finalVerifyCode = ref(null)
const registerLoading = ref(false)
const toRegister = async () => {
    await verifyCodeFormRef.value?.validate()
    finalVerifyCode.value = verifyCodeForm.value.verifyCode
    currentStep.value++
    return
    if (registerLoading.value) return
    registerLoading.value = true
    try {
        const { email, verifyCode } = verifyCodeForm.value
        const data_ = {
            email,
            ticket: verifyCode,
        }
        const res = await checkEmailVerifyCodeStatusApi(data_)
        if (res.status === 200) {
            finalVerifyCode.value = verifyCode
            currentStep.value++
        } else {
            noticeMessagePopup(
                res.message,
                t('common.tip'),
                'warning',
                3000,
                'cool-notification'
            )
        }
    } catch (error) {
        console.log(error)
    } finally {
        registerLoading.value = false
    }
}

const formRef = ref(null)
const sendVerifyCodeBtn = ref(null)
const signUpLoading = ref(false)
const signInLoading = ref(false)
const checkEmailStatusLoading = ref(false)
const googleLoginLoading = ref(false)
const loading = ref(false)
const resetPwd = ref(false)

const pwdFormRef = ref(null)
const pwdForm = ref({
    // register_code: '',
    password: '',
    confirmPassword: '',
})
const pwdFormRule = ref({
    password: [
        { validator: passwordValidator, trigger: 'blur' },
        { min: 8, max: 20, message: t('rules.password3'), trigger: 'blur' },
        { message: t('rules.password2'), trigger: 'blur', pattern: /^\S*$/ },
    ],
    confirmPassword: [{ validator: confirmPasswordValidator, trigger: 'blur' }],
})
// email login
const signInFormRef = ref(null)
const signInForm = ref({
    password: '',
})

// email is valid
const isEmailValid = ref(false)

// email blur validation
const validateEmail = async () => {
    try {
        await formRef.value?.validateField('email')
        isEmailValid.value = true
    } catch (_error) {
        isEmailValid.value = false
    }
}

const registerLoding = ref(false)
const handleRegister = async () => {
    await pwdFormRef.value?.validate()
    if (registerLoding.value) return
    registerLoding.value = true
    const data = {
        email: verifyCodeForm.value.email,
        pwd: pwdForm.value.password,
        ticket: finalVerifyCode.value,
        oauth_enum: 'EMAIL_REGISTERED',
        // registration_code: pwdForm.value.register_code,
    }
    const invite_code = storage.get('invite_code')
    if (invite_code) {
        data.invite_code = invite_code
    }
    // 添加奖励邀请码
    const reward_invite_code = storage.get('reward_invite_code')
    if (reward_invite_code) {
        data.reward_invite_code = reward_invite_code
    }
    try {
        const res = await loginApi(data)
        if (res.status === 200) {
            noticeMessagePopup(
                t('rules.register_success'),
                t('common.tip'),
                'success',
                3000,
                'cool-notification'
            )
            hasLoginForGetInitInfo(res, 'email')
        } else if (res.status === 500) {
            showLoginApiError(res, t('rules.register_failed'), 'error')
        } else {
            showLoginApiError(res, t('rules.register_failed'))
        }
    } catch (e) {
        showLoginApiError(e?.data, t('rules.register_failed'))
    } finally {
        registerLoding.value = false
    }
}

const resetPasswordFormRef = ref(null)
const resetPasswordForm = ref({
    email: '',
    password: '',
    confirmPassword: '',
    verifyCode: '',
})
const resetPasswordRules = ref({
    email: [{ validator: emailValidator, trigger: 'blur' }],
    password: [
        { validator: passwordValidator, trigger: 'blur' },
        { min: 8, max: 20, message: t('rules.password3'), trigger: 'blur' },
        { message: t('rules.password2'), trigger: 'blur', pattern: /^\S*$/ },
    ],
    confirmPassword: [{ validator: confirmPasswordValidator, trigger: 'blur' }],
    verifyCode: [{ validator: verifyCodeValidator, trigger: 'blur' }],
})

// reset verifyCode status
const resetVerifyCode = () => {
    loginForm.value.verifyCode = ''
    countDown.value = 0
    if (timer.value) {
        clearInterval(timer.value)
        timer.value = null
    }
}

const resetPwdLoading = ref(false)
const handleResetPassword = async () => {
    await resetPasswordFormRef.value?.validate()
    if (resetPwdLoading.value) return
    resetPwdLoading.value = true
    const data = {
        email: resetPasswordForm.value.email,
        pwd: resetPasswordForm.value.password,
        ticket: resetPasswordForm.value.verifyCode,
    }
    const res = await resetPasswordApi(data)
    if (res.status === 200) {
        noticeMessagePopup(
            t('rules.reset_password_success'),
            t('common.tip'),
            'success',
            3000,
            ''
        )

        resetPwdLoading.value = false //reset register/reset loading
        countDown.value = 0 //reset verifyCode countdown
        if (timer.value) {
            clearInterval(timer.value)
            timer.value = null
        }
        currentStep.value = 0
        resetPasswordFormRef.value.resetFields()
    } else if (res.status === 500) {
        noticeMessagePopup(res.desc || t('rules.reset_password_failed'))
        resetPwdLoading.value = false
    } else {
        resetPwdLoading.value = false
    }
}

// find password

const resetPassword = () => {
    steps.value = stepEnums.filter(
        item =>
            item.value !== 'reset_password' &&
            item.value !== 'sign_in_with_email'
    )
    currentStep.value = 1
    resetPwd.value = true
    signInFormRef.value.resetFields()
    nextTick(() => {
        if (sendVerifyCodeBtn.value) {
            sendVerifyCodeBtn.value.click()
        }
    })
}

// const signUpOrResetPwd = computed(() => {
//   return resetPwd.value ? handleResetPassword : handleSignUp;
// });

// google login
const googleLogin = async (type = 'login') => {
    loginFormRef.value?.resetFields()
    getVerificationFormRef.value?.resetFields()
    verifyCodeFormRef.value?.resetFields()
    phoneLoginFormRef.value?.resetFields()
    pwdFormRef.value?.resetFields()
    resetPasswordFormRef.value?.resetFields()

    googleLoginLoading.value = true
    const provider_google = new GoogleAuthProvider()
    const auth = firebaseAuth
    if (!auth) return // 兼容 SSR 或初始化失败
    auth.languageCode = 'it'
    provider_google.addScope('email')
    provider_google.addScope('profile')
    signInWithPopup(auth, provider_google)
        .then(result => {
            const credential = GoogleAuthProvider.credentialFromResult(result)
            const { accessToken: _accessToken, idToken } = credential
            const data = {
                access_token: idToken,
                openid: result.user.providerData[0].uid,
                oauth_enum: 'GOOGLE',
            }
            const invite_code = storage.get('invite_code')

            if (invite_code) {
                data.invite_code = invite_code
            }
            // 添加奖励邀请码
            const reward_invite_code = storage.get('reward_invite_code')
            if (reward_invite_code) {
                data.reward_invite_code = reward_invite_code
            }
            loading.value = true
            loginApi(data).then(async res => {
                if (res.status === 200) {
                    loading.value = false
                    hasLoginForGetInitInfo(res, 'google')
                } else if (res.status === 500) {
                    showLoginApiError(res, t('rules.login_failed'), 'error')
                    loading.value = false
                    googleLoginLoading.value = false
                } else {
                    showLoginApiError(res)
                    loading.value = false
                    googleLoginLoading.value = false
                }
            }).catch(error => {
                showLoginApiError(error?.data)
                loading.value = false
                googleLoginLoading.value = false
            })
        })
        .catch(error => {
            if (error.code === 'auth/popup-blocked') {
                noticeMessagePopup(
                    t('rules.login_popup_blocked'),
                    t('common.tip'),
                    'warning',
                    3000,
                    'cool-notification'
                )
                googleLoginLoading.value = false
            } else if (error.code === 'auth/internal-error') {
                noticeMessagePopup(
                    t('rules.login_popup_failed'),
                    t('common.tip'),
                    'warning',
                    3000,
                    'cool-notification'
                )
                googleLoginLoading.value = false
            }
            // else if (error.code === "auth/popup-closed-by-user") {
            //   googleLoginLoading.value = false;
            // }
            console.log(error)
            let _error = ''
            if (typeof error === 'string') {
                _error = error.slice(0, 50)
            } else if (typeof error === 'object' && error !== null) {
                _error = JSON.stringify(error).slice(0, 50)
            }
        })
        .finally(() => {
            googleLoginLoading.value = false
            loading.value = false
        })
}

const googleLoginByRegister = () => {
    googleLogin('register')
}

const checkEmailStatus = async () => {
    await formRef.value?.validateField('email')
    if (checkEmailStatusLoading.value) return
    checkEmailStatusLoading.value = true
    const res = await checkEmailStatusApi({ email: loginForm.value.email })
    if (res.status === 200) {
        if (res.data) {
            steps.value = [stepEnums[0], stepEnums[3]]
        } else {
            steps.value = stepEnums.filter(
                item => item.value !== 'sign_in_with_email'
            )
            resetPwd.value = false
        }
        currentStep.value = 1
    }
    checkEmailStatusLoading.value = false
    nextTick(() => {
        if (sendVerifyCodeBtn.value) {
            sendVerifyCodeBtn.value.click()
        }
    })
}

onMounted(() => {
    // 事件监听器已在上面定义，这里不需要重复添加
})
// clean timer when component unmount
onUnmounted(() => {
    if (timer.value) {
        clearInterval(timer.value)
        timer.value = null
    }
    clearPhoneVerifyCodeTimer()
})

watch(
    () => showLoginModal.value,
    newVal => {
        if (!newVal) {
            currentStep.value = 0
            loginMode.value = DEFAULT_LOGIN_MODE
            loginForm.value.email = ''
            loginForm.value.password = ''
            phoneLoginForm.value.areaCode = FIXED_PHONE_AREA_CODE
            phoneLoginForm.value.phone = ''
            phoneLoginForm.value.verifyCode = ''
            clearPhoneVerifyCodeTimer()
            // 重置校验规则
            loginFormRef.value?.resetFields()
            phoneLoginFormRef.value?.resetFields()
        }
    }
)
</script>

<style scoped lang="less">
// 邀请提示条样式
.invite-banner {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 18px;
    border-radius: 20px 20px 0 0;
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-bottom: none;
    // 毛玻璃效果
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    width: 85%;
    max-width: 454px;
    box-sizing: border-box;
    margin: 0 auto;

    @media (max-width: 768px) {
        padding: 12px 14px;
        gap: 10px;
    }
}

.invite-horn-icon {
    width: 44px;
    height: 44px;
    flex-shrink: 0;

    @media (max-width: 768px) {
        width: 36px;
        height: 36px;
    }
}

.invite-banner-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.invite-banner-text {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;

    @media (max-width: 768px) {
        font-size: 13px;
    }
}

.inviter-name {
    color: #ffffff;
    font-weight: 700;
}

.invite-banner-reward {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.8);

    @media (max-width: 768px) {
        font-size: 12px;
    }
}

.reward-points {
    color: #4ade80;
    font-weight: 600;
}

.login-bg {
    box-sizing: border-box;
    width: 100%;
    max-width: 454px;
    min-height: 430px;
    height: auto;
    border-radius: 16px;
    background-color: #191921;
    background-image: url('../assets/images/common/login_bg.webp');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    @media (min-width: 768px) {
        width: 454px;
        min-height: 500px;
        height: auto;
    }
}

.login-step-bg {
    min-height: 390px;

    @media (min-width: 768px) {
        min-height: 450px;
    }
}

.login-container {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
}

.illustration-section {
    flex: 1;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
}

.login-section {
    display: flex;

    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    position: relative;
}

.close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: white;
    transition: background 0.3s;
}

.close-button:hover {
    background: rgba(255, 255, 255, 0.1);
}

.logo h1 {
    color: white;
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 20px;
    letter-spacing: 2px;
}

.login-hint p {
    font-size: 16px;
    margin-bottom: 40px;
    text-align: center;
}

.google-login-btn {
    height: 50px;
    display: flex;
    padding: 15px 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 4px 13.8px 0 rgba(0, 0, 0, 0.2) inset;

    @media (min-width: 768px) {
        height: 64px;
        padding: 20px;
    }
}

.google-login-btn:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.google-icon {
    width: 20px;
    height: 20px;
}

.google-login-btn span {
    color: #333;
    font-size: 16px;
    font-weight: 500;
}

.divider {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px 0;

    @media (min-width: 768px) {
        margin: 20px 0;
    }
}

.divider-line-right {
    width: 20px;
    height: 1px;
    background: linear-gradient(
        270deg,
        #adadad 0%,
        rgba(126, 126, 126, 0) 100%
    );
}

.divider-line-left {
    width: 20px;
    height: 1px;
    background: linear-gradient(90deg, #adadad 0%, rgba(126, 126, 126, 0) 100%);
}

.divider span {
    color: #888;
    padding: 0 20px;
    font-size: 14px;
}

.login-bottom-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
    margin-top: -2px;
}

.login-register-line,
.login-secondary-line {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #545463;
    font-size: 12px;

    @media (min-width: 768px) {
        font-size: 14px;
    }
}

.login-mode-switch-btn {
    line-height: 20px;
    padding: 0;
    border: none;
    color: var(--el-menu-active-color);
    font-size: inherit;
    font-weight: 600;
    background: transparent;
    cursor: pointer;
    transition:
        color 0.2s ease,
        opacity 0.2s ease;
}

.login-mode-switch-btn:hover {
    color: #ffffff;
    text-decoration: underline;
}

.login-secondary-divider {
    width: 1px;
    height: 12px;
    margin: 0 12px;
    background: rgba(255, 255, 255, 0.18);
}

.login-forgot-password {
    color: var(--el-menu-active-color);
    font-weight: 600;
    cursor: pointer;
}

.login-forgot-password:hover {
    color: #ffffff;
    text-decoration: underline;
}

.phone-login-row {
    width: 100%;
}

.phone-login-row :deep(.el-form-item) {
    margin-bottom: 0;
}

.phone-combined-input {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 50px;
    border-radius: 8px;
    background: transparent;
    box-shadow: 0 0 0 1px #ffffff4d inset;
    transition: box-shadow 0.2s ease;

    @media (min-width: 768px) {
        min-height: 60px;
    }
}

.phone-combined-input:focus-within {
    box-shadow: 0 0 0 1px #ffffff80 inset;
}

.phone-combined-input :deep(.el-input__wrapper) {
    min-height: 50px;
    padding: 1px 15px;
    border-radius: 0;
    box-shadow: none !important;

    @media (min-width: 768px) {
        min-height: 60px;
        padding: 1px 20px;
    }
}

.phone-combined-input :deep(.el-input__wrapper.is-focus),
.phone-combined-input :deep(.el-input__inner:focus) {
    border-color: transparent !important;
    box-shadow: none !important;
    outline: none !important;
}

.phone-area-item {
    flex: 0 0 96px;
}

.phone-fixed-area-code {
    display: flex;
    align-items: center;
    min-height: 50px;
    padding: 1px 15px;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
    user-select: none;
    cursor: default;

    @media (min-width: 768px) {
        min-height: 60px;
        padding: 1px 20px;
    }
}

.phone-number-item {
    flex: 1;
    min-width: 0;
}

.phone-input-divider {
    width: 1px;
    height: 28px;
    flex: 0 0 1px;
    background: rgba(255, 255, 255, 0.2);
}

.phone-prefix {
    color: #fff;
    font-weight: 600;
}

.email-login {
    width: 100%;
}

.input-group {
    margin-bottom: 20px;
}

.input-group label {
    display: block;
    color: #cccccc;
    font-size: 14px;
    margin-bottom: 8px;
}

.input-group input {
    width: 100%;
    height: 60px;
    background: #fff;
    border: 1px solid #c3c3c3;
    border-radius: 8px;
    padding: 20px 20px 20px 0;
    color: #333;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
}

.input-group input::placeholder {
    color: #888;
}

.input-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
}

.confirm-btn {
    margin: 0 auto;
    width: 100%;
    max-width: 394px;
    height: 50px;
    border-radius: 8px;
    background: var(--el-menu-active-color);
    border: none;
    color: #000;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    position: relative;
    transition: all 0.3s;

    &:disabled {
        background: #22242d;
        cursor: not-allowed;
        color: #999;
    }

    &:hover {
        transform: scale(1.05);
    }

    @media (min-width: 768px) {
        height: 56px;
        font-size: 16px;
    }
}

@media (max-width: 768px) {
    .login-container {
        flex-direction: column;
    }

    .illustration-section {
        display: none;
    }

    .login-section {
        flex: none;
        height: 100vh;
    }
}

.info-icon {
    font-size: 14px;
    color: #909399;
    cursor: help;
    margin-left: 4px;
}

:deep(.el-dialog__body) {
    background: transparent !important;
}

:deep(.el-input__wrapper) {
    color: #fff;
    font-weight: 500;
    background-color: transparent !important;
    background: transparent !important;
    border-radius: 8px;
    padding: 1px 15px;
    min-height: 50px;
    box-shadow: 0 0 0 1px #ffffff4d inset !important;

    @media (min-width: 768px) {
        padding: 1px 20px;
        min-height: 60px;
    }
}

:deep(.el-input__wrapper.is-focus) {
    border-color: #ffffff80 !important;
}

:deep(.el-input__inner) {
    background-color: transparent !important;
    background: transparent !important;
    color: #fff !important;
}

:deep(.el-input) {
    background-color: transparent !important;
    background: transparent !important;
}

:deep(.el-input input) {
    background-color: transparent !important;
    background: transparent !important;
    color: #fff !important;
}

:deep(.el-input input:-webkit-autofill) {
    -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
    -webkit-text-fill-color: #fff !important;
    background-color: transparent !important;
    background: transparent !important;
    transition: background-color 5000s ease-in-out 0s;
}

:deep(.el-input input:-webkit-autofill:hover) {
    -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
    -webkit-text-fill-color: #fff !important;
    background-color: transparent !important;
    background: transparent !important;
}

:deep(.el-input input:-webkit-autofill:focus) {
    -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
    -webkit-text-fill-color: #fff !important;
    background-color: transparent !important;
    background: transparent !important;
}

:deep(.el-input input:-webkit-autofill:active) {
    -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
    -webkit-text-fill-color: #fff !important;
    background-color: transparent !important;
    background: transparent !important;
}

.phone-combined-input :deep(.el-input),
.phone-combined-input :deep(.el-input__wrapper),
.phone-combined-input :deep(.el-input__wrapper.is-focus),
.phone-combined-input :deep(.el-input.is-focus .el-input__wrapper) {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: transparent !important;
}

.phone-combined-input :deep(.el-input__inner),
.phone-combined-input :deep(.el-input__inner:focus),
.phone-combined-input :deep(.el-input__inner:focus-visible) {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}
</style>

<style>
.login-modal {
    background: transparent;
    box-shadow: none;
    transition: all 0.3s ease-in-out;
}

.login-modal .el-dialog {
    border-radius: 10px !important;
    overflow: hidden;
    transform: translateZ(0) !important;
    -webkit-transform: translateZ(0) !important;
    will-change: transform !important;
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
    backface-visibility: hidden !important;
    -webkit-backface-visibility: hidden !important;
    shape-rendering: crispEdges !important;
    -webkit-appearance: none !important;
    appearance: none !important;
    isolation: isolate !important;
}

@media (max-width: 1300px) {
    .login-modal .el-dialog {
        width: 408px !important;
        /* 454px * 0.9 */
        height: auto !important;
        border-radius: 10px !important;
    }

    .login-bg {
        width: 408px !important;
        border-radius: 10px;
    }
}

@media (max-width: 768px) {
    .login-modal .el-dialog {
        width: 90vw !important;
        max-width: 90vw !important;
        height: auto !important;
        min-height: unset !important;
        max-height: 90vh !important;
        border-radius: 10px !important;
        overflow-y: auto !important;
    }

    .login-bg {
        width: 408px !important;
        max-width: 100% !important;
        height: auto !important;
        min-height: 430px !important;
        border-radius: 10px;
    }

    .login-step-bg {
        min-height: 390px !important;
        padding-bottom: 18px !important;
    }

    .login-bottom-actions {
        gap: 6px;
        margin-top: -8px;
    }

    .mobile-input :deep(.el-input__wrapper) {
        min-height: 50px !important;
    }
}

@media (max-width: 480px) {
    .login-modal .el-dialog {
        width: 90vw !important;
        max-width: 90vw !important;
        height: auto !important;
        min-height: unset !important;
        max-height: 90vh !important;
    }

    .login-bg {
        width: 90vw !important;
        max-width: 100% !important;
        height: auto !important;
        min-height: 430px !important;
        border-radius: 10px;
    }

    .login-step-bg {
        min-height: 390px !important;
        padding-bottom: 18px !important;
    }
}
</style>
